"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stitch_1 = require("../../stitch");

var bson_1 = require("bson");

var lodash_1 = require("lodash");

var events_1 = require("events");

var AnvokError_1 = __importDefault(require("../../AnvokError"));

var GenericRepo =
/** @class */
function () {
  function GenericRepo(coll, user) {
    var _this = this;

    this.emitter = new events_1.EventEmitter();
    this.listeners = [];
    this.watchIds = [];

    this.onWatchNext = function (event) {
      var operationType = event.operationType,
          id = event.id,
          fullDocument = event.fullDocument;

      if (!fullDocument) {
        return;
      }

      if (operationType === stitch_1.StitchOperationType.Update) {
        _this.listeners.forEach(function (l) {
          if (l.ids.indexOf(id)) {
            l.callback(fullDocument);
          }
        });
      }
    };

    this.onWatchError = function (error) {
      console.error("Watch failed, retrying...", error);
      _this.watchIds = [];

      _this.updateStream();
    };

    if (!user) {
      throw new Error("Repository access restricted");
    }

    this.coll = coll;
    this.user = user;
  }

  GenericRepo.prototype.on = function (event, listener) {
    this.emitter.on(event, listener);
    return this;
  };

  GenericRepo.prototype.off = function (event, listener) {
    this.emitter.off(event, listener);
    return this;
  };

  GenericRepo.prototype.watch = function (ids, callback) {
    this.listeners.push({
      ids: ids,
      callback: callback
    });
    this.updateStream();
  };

  GenericRepo.prototype.unwatch = function (callback) {
    lodash_1.remove(this.listeners, function (n) {
      return n.callback === callback;
    });
    this.updateStream();
  };

  GenericRepo.prototype.updateStream = function () {
    var _this = this;

    var ids = this.listeners.reduce(function (acc, cur) {
      return lodash_1.union(acc, cur.ids);
    }, []);
    var u = lodash_1.union(this.watchIds, ids);

    if (u.length !== ids.length || u.length !== this.watchIds.length) {
      this.watchIds = ids;

      if (ids.length === 0 && this.watchStream) {
        this.watchStream.close();
        this.watchStream = undefined;
      } else {
        this.coll.watch(this.watchIds).then(function (s) {
          s.onNext(_this.onWatchNext);
          s.onError(_this.onWatchError);

          if (_this.watchStream) {
            _this.watchStream.close();
          }

          _this.watchStream = s;
        }).catch(console.error);
      }
    }
  };

  GenericRepo.prototype.get = function (id) {
    var _this = this;

    return this.ensureObjectId(id).then(function (id) {
      return _this.coll.findOne({
        _id: id
      });
    });
  };

  GenericRepo.prototype.list = function (sort, projection) {
    if (sort === void 0) {
      sort = {};
    }

    if (projection === void 0) {
      projection = {};
    }

    return this.coll.find({}, {
      sort: sort,
      projection: projection
    }).asArray();
  };

  GenericRepo.prototype.find = function (query, sort, projection, limit) {
    if (query === void 0) {
      query = {};
    }

    if (sort === void 0) {
      sort = {};
    }

    if (projection === void 0) {
      projection = {};
    }

    return this.coll.find(query, {
      sort: sort,
      projection: projection,
      limit: limit
    }).asArray();
  };

  GenericRepo.prototype.save = function (o) {
    var _this = this;

    return new Promise(function (res, rej) {
      o.owner = _this.user.id;
      o.org = _this.user.org;
      o.modified = new Date();

      if (o._id) {
        _this.coll.updateOne({
          _id: o._id
        }, {
          $set: o
        }).then(function () {
          _this.emitter.emit("updated", o._id, o);

          res(o._id);
        }).catch(rej);
      } else {
        o.created = new Date();

        _this.coll.insertOne(o).then(function (r) {
          _this.emitter.emit("inserted", r.insertedId, o);

          res(r.insertedId);
        }).catch(rej);
      }
    });
  };

  GenericRepo.prototype.update = function (o) {
    var _this = this;

    return new Promise(function (res, rej) {
      o.modified = new Date();
      var id = o._id;
      delete o._id;

      _this.coll.updateOne({
        _id: id
      }, {
        $set: o
      }).then(function () {
        _this.emitter.emit("updated", id, o);

        res(id);
      }).catch(rej);
    });
  };

  GenericRepo.prototype.findOneAndUpdate = function (query, o) {
    var _this = this;

    if (query === void 0) {
      query = {};
    }

    return new Promise(function (res, rej) {
      o.modified = new Date();

      _this.coll.findOneAndUpdate(query, {
        $set: o
      }, {
        returnNewDocument: true
      }).then(function (doc) {
        res(doc);
      }).catch(rej);
    });
  };

  GenericRepo.prototype.delete = function (o) {
    var _this = this;

    var id;

    if (o instanceof bson_1.ObjectId) {
      id = o;
    } else {
      id = o._id;
    }

    return new Promise(function (res, rej) {
      _this.coll.delete({
        _id: id
      }).then(function (r) {
        if (r.deletedCount === 1) {
          _this.emitter.emit("deleted", id, o);

          res(id);
        } else {
          rej("Erreur suppression : enregistrement introuvable");
        }
      }).catch(rej);
    });
  };

  GenericRepo.prototype.listByIds = function (ids, sort, projection) {
    var _this = this;

    if (sort === void 0) {
      sort = {
        place: 1,
        label: 1
      };
    }

    if (projection === void 0) {
      projection = {};
    }

    return this.ensureObjectIds(ids).then(function (ids) {
      return _this.find({
        _id: {
          $in: ids
        }
      }, sort, projection);
    });
  };

  GenericRepo.prototype.ensureObjectId = function (id) {
    return new Promise(function (res, rej) {
      try {
        id = id instanceof bson_1.ObjectId ? id : bson_1.ObjectId.createFromHexString(id);
        res(id);
      } catch (_a) {
        rej(new AnvokError_1.default("Format d'argument incorrect", "err"));
      }
    });
  };

  GenericRepo.prototype.ensureObjectIds = function (ids) {
    return new Promise(function (res, rej) {
      try {
        var r = ids.map(function (id) {
          return id instanceof bson_1.ObjectId ? id : bson_1.ObjectId.createFromHexString(id);
        });
        res(r);
      } catch (_a) {
        rej(new AnvokError_1.default("Format d'arguments incorrect", "err"));
      }
    });
  };

  return GenericRepo;
}();

exports.default = GenericRepo;